/**
 * Fullheight panels must be sized on load and on resize
 * vh is not trusted at this point. too many bugs are present.
 * */

(function($) {

    /**
     * Because min-height: 100vh DOES NOT WORK
     *
     *  go through each full height panel and get its height in px
     *  also get height of each content panel within
     *
     *  if content panel > wrapper panel, make wrapper panel that height
     *
     *
     * */


})( jQuery );
